module.exports = __webpack_public_path__ + "../../img/laptop.18203b8c.png";